import React, { Suspense } from "react";
import styled, { css } from "styled-components";
import { Colors } from "../../../theme/colors";

type AdviceType = "info";

interface AdviceProps {
  text: string;
  type: AdviceType;
}

const Advice = ({ text, type }: AdviceProps) => {
  const iconSVG = getIconSVG(type);

  return (
    <Container>
      <Suspense fallback={null}>
        <IconSVG as={iconSVG} type={type} />
      </Suspense>

      <Text>{text}</Text>
    </Container>
  );
};

const getIconSVG = (type: AdviceType) => {
  switch (type) {
    case "info":
      return InfoSVG;
  }
};

const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  background-color: ${Colors.White};
  padding: ${8 * 2}px;
  border-radius: 15px;
`;

const IconSVG = styled.div<{
  type: AdviceType;
}>`
  ${(props) => {
    const type = props.type;
    switch (type) {
      case "info":
        return css`
          fill: ${Colors.Primary};
        `;
    }
  }}

  margin-right: ${8 * 2}px;
  width: 25px;
  height: 25px;
  min-width: 25px;
  min-height: 25px;
`;

const Text = styled.div``;

const InfoSVG = React.lazy(() => import("../Svg/InfoSVG"));

export default Advice;
